import React from "react";
import { useFormContext } from "react-hook-form";
import { Text } from "@mantine/core";
import { NewOrderType, TNewOrderForm } from "@/entities/new-order";
import { useAppSelector } from "@/Hooks/redux/useAppSelector";
import { AddNewCountryButton } from "@/features/new-order";
import {
  getTotalCurrentTypeName,
  getTotalKeywordsCountFromCountries,
  getTotalOrderCost,
  getTotalViewsCount,
} from "@/Pages/CreateCampaignPage/Helpers/CreateOrderHelpers";
import styles from "./countries-block.module.scss";

interface CountriesTotalProps {
  append: (value: TNewOrderForm["countriesList"][number]) => void;
}

export const CountriesTotal = ({ append }: CountriesTotalProps) => {
  const { watch } = useFormContext<TNewOrderForm>();
  const { user } = useAppSelector((state) => state.clientDataSlice);

  const { app, type, countriesList, attributesList } = watch();

  return (
    <div className={styles.total}>
      <AddNewCountryButton append={append} />
      <div className={styles.total_block}>
        {!!(app && type && user && countriesList.length) && (
          <div className={styles.total_item}>
            <Text className={styles.total_value_span}>Campaign price:</Text>
            <Text className={styles.total_value}>
              {getTotalOrderCost(
                app,
                user,
                countriesList,
                type,
                attributesList,
              )?.toFixed(2)}{" "}
              $
            </Text>
          </div>
        )}
        {!!(countriesList.length && type) && (
          <div className={styles.total_item}>
            <Text className={styles.total_value_span}>
              Total {getTotalCurrentTypeName(type)}
            </Text>
            <Text className={styles.total_value}>
              {getTotalKeywordsCountFromCountries(countriesList)}
            </Text>
          </div>
        )}
        {Boolean(countriesList.length) &&
          type === NewOrderType.install_with_views && (
            <div className={styles.total_item}>
              <Text className={styles.total_value_span}>
                Additional impressions:
              </Text>
              <Text className={styles.total_value}>
                {getTotalViewsCount(countriesList)}
              </Text>
            </div>
          )}
      </div>
    </div>
  );
};
